import styled from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import {
  DATA_E2E_KEY,
  DRAG_HANDLE_WIDTH,
  IStyledAttributes,
} from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const AreasGridTableWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "areas-grid-table-panel-wrapper",
})`
  min-width: 100%;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${rydeColors.smoke};

  .grid_panel {
    background-color: ${greyMui._100};
    overflow: auto;
    position: absolute;
  }
  .splitter {
    position: absolute;
    inset-inline-start: 0;
    top: 0;
    bottom: 0;
    background-color: ${greyMui._300};
    cursor: col-resize;
    width: ${DRAG_HANDLE_WIDTH}px;
    z-index: ${ScreenDepth.GRID_SPLITTER};
    &:hover {
      background-color: ${greyMui._400};
    }
  }
  .map_panel {
    position: absolute;
    inset-inline-end: 0;
    top: 0;
    bottom: 0;
    background-color: ${rydeColors.smoke};
    padding: 3px;
    margin-inline-start: ${DRAG_HANDLE_WIDTH - 1}px;
  }
`;

export const AreasGridMapStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "areas-grid-map-wrapper",
})`
  height: 100%;
  width: 100%;
  position: relative;

  div.map_scrollable_content {
    min-width: max(100%, 250px);
    height: 100%;
  }

  .empty-state {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 12px 18px;
    background: ${rydeColors.white};
    border: 1px solid ${blueGreyMui._200};
    border-radius: 4px;
    color: ${blueGreyMui._500};
    font-size: 14px;
    text-align: center;
    z-index: ${ScreenDepth.FLOATING_MENU};
    pointer-events: none;
  }
`;

/** The areas map itself — fills the map panel that the splitter sizes. */
export const AreasMapHostStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "areas-grid-map",
})`
  height: 100%;
  width: 100%;
`;
